module.exports = __webpack_public_path__ + "media/LandingPageAssets/FiveStar-323de07d.svg";